export namespace ReviewsValidations {
  export const isNumberOfRatingsValid = (x: number) => {
    return Number.isFinite(x) && x >= 0;
  };
  export const isRatingValueValid = (x: number) => {
    return Number.isFinite(x) && x >= 0 && x <= 5;
  };
}
